<div class="wrapper">
  <div class="page-wrapper pt-4">
    <div class="page-content pt-0 px-2">
      <div class="container-fluid">
        <div class="content-wrapper p-0">
          <div class=" mt-2 mb-2">
            <!-- TOP SECTION -->
            <div class="row">
              <div class="col-xl-12">
                <div class="card h-100">
                  <div class="card-header bg-white">
                    <div class="card-title mb-0"> <strong>Institutions</strong></div>
                  </div>
                  <div class="card-body">
                    <!-- <div class="row">
                        <div class="col-xl-6">
                          <div class="form-group row pt-4">
                            <label class="col-md-4 control-label">
                              County</label>
                            <div class="col-md-8 inputGroupContainer">
                              <div class="input-group">
                                <select [(ngModel)]="countyId" class="form-select shadow-sm rounded-lg"
                                  (change)="subCountyId='';LoadSubCounties();LoadGridList()">
                                  <option value="" selected>Select County</option>
                                  <option *ngFor="let item of countyList" [value]="item.COUNTIES_CODE">
                                    {{ item.COUNTIES_NAME }}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-xl-6">
                          <div class="form-group row pt-4">
                            <label class="col-md-4 control-label">
                              Subcounty</label>
                            <div class="col-md-8 inputGroupContainer">
                              <div class="input-group">
                                <select [(ngModel)]="subCountyId" class="form-select shadow-sm rounded-lg"
                                  (change)="LoadGridList()">
                                  <option value="" selected>Select Subcounty</option>
                                  <option *ngFor="let item of subCountyList" [value]="item.sub_counties_id">
                                    {{ item.sub_counties_name }}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> -->
                    <div class="table-responsive" *ngIf="gridList.length">
                      <table datatable id="DataTables_Table_0"
                        class="table-striped table-bordered mt-2 pt-2 table-sm small" style="width: 100%;">
                        <thead class="top" style="background-color: #624fd7; color: #ffffff !important">
                          <tr>
                            <th class="d-none">S. No</th>
                            <th>Institution No.</th>
                            <th>School Name</th>
                            <th>County</th>
                            <th>Subcounty</th>
                            <th>Status</th>
                            <th>View</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let item of gridList; let i = index">
                            <td class="d-none">{{i+1}}</td>
                            <td>{{item.REGISTRATION_NO}}</td>
                            <td>{{item.TNT_NAME}}</td>
                            <td>{{item.COUNTIES_NAME}}</td>
                            <td>{{item.SUB_COUNTIES_NAME}}</td>
                            <td>{{item.SUBMISSION_STATUS}}</td>
                            <td> <button class="btn btn-outline-danger btn-sm" data-bs-toggle="modal"
                                (click)="viewDocument(item)" data-bs-target="#detailsModal">
                                <i class="fas fa-eye me-1"></i> View
                              </button></td>
                            <!-- <td></td>
                              <td></td> -->
                          </tr>
                        </tbody>
                        <tbody *ngIf="!gridList.length">
                          <tr>
                            <td colspan="8" class="text-center">No Records Found</td>
                          </tr>
                        </tbody>

                      </table>
                    </div>
                  </div>

                </div>

              </div>
            </div>
            <!-- TABLE -->
          </div>
          <!-- </body> -->
        </div>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="detailsModal" tabindex="-1" aria-labelledby="detailsModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title text-primary" id="detailsModalLabel" style="color: #ffffff !important;">
          Institution Name - {{ approveData?.TNT_NAME }}
          <span class="badge status-badge status-pending ms-3">
            <span *ngIf="[2, 4, 5].includes(approveData?.IS_APPROVED)" class="badge bg-success ms-1">Approved</span>
            <span *ngIf="approveData?.submission_status == 5 && ![2, 4, 5].includes(approveData?.IS_APPROVED)"
              class="badge bg-danger ms-1">Rejected</span>
            <span *ngIf="approveData?.submission_status != 5 && ![2, 4, 5].includes(approveData?.IS_APPROVED)"
              class="badge bg-warning ms-1">Pending</span>
            CDE Review</span>
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" id="institutnDtlsId"
          aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <!-- Nav tabs -->
        <ul class="nav nav-tabs" id="detailsTabs" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link active" id="registration-tab" data-bs-toggle="tab" data-bs-target="#registration"
              type="button" role="tab">
              Institution Registration Form
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="comments-tab" data-bs-toggle="tab" data-bs-target="#comments" type="button"
              role="tab">
              Comments & Reports
            </button>
          </li>
          <!-- <li class="nav-item" role="presentation">
            <button class="nav-link" id="actions-tab" data-bs-toggle="tab" data-bs-target="#actions" type="button"
              role="tab">
              Actions
            </button>
          </li> -->
        </ul>

        <!-- Tab panes -->
        <div class="tab-content mt-3" id="detailsTabContent">
          <!-- Registration Tab -->
          <div class="tab-pane fade show active" id="registration" role="tabpanel">
            <div class="registration-form-content bg-light p-4 rounded border">
              <h3 class="text-primary mb-2">Institution Registration Form</h3>
              <p class="text-muted mb-4">
                Complete institution details as provided during registration
              </p>

              <div class="row">
                <div class="col-md-4">
                  <h5 class="border-bottom pb-2">Basic Institution Details</h5>
                  <div class="mb-3">
                    <label class="form-label fw-medium">Institution Type *</label>
                    <div class="form-control-plaintext border rounded bg-white p-2">
                      {{
                      userDetails?.institution_type == 1
                      ? "Boys School"
                      : userDetails?.institution_type == 2
                      ? "Girls School"
                      : "Mixed School"
                      }}
                    </div>
                  </div>
                  <div class="mb-3">
                    <label class="form-label fw-medium">Institution Name *</label>
                    <div class="form-control-plaintext border rounded bg-white p-2">
                      {{ userDetails?.TNT_NAME }}
                    </div>
                  </div>
                  <div class="mb-3">
                    <label class="form-label fw-medium">Email *</label>
                    <div class="form-control-plaintext border rounded bg-white p-2">
                      {{ userDetails?.email }}
                    </div>
                  </div>
                  <div class="mb-3">
                    <label class="form-label fw-medium">Mobile Number *</label>
                    <div class="form-control-plaintext border rounded bg-white p-2">
                      {{ userDetails?.mobileno }}
                    </div>
                  </div>
                  <div class="mb-3">
                    <label class="form-label fw-medium">Coordinates</label>
                    <div class="form-control-plaintext border rounded bg-white p-2">
                      <span>Latitude: </span>{{ userDetails?.latitude }}<span>-Longitude:
                      </span>{{userDetails?.longitude}}
                    </div>
                  </div>
                </div>

                <div class="col-md-4">
                  <h5 class="border-bottom pb-2">Location Information</h5>
                  <div class="mb-3">
                    <label class="form-label fw-medium">County *</label>
                    <div class="form-control-plaintext border rounded bg-white p-2">
                      {{ userDetails?.counties_name }}
                    </div>
                  </div>
                  <div class="mb-3">
                    <label class="form-label fw-medium">Sub County *</label>
                    <div class="form-control-plaintext border rounded bg-white p-2">
                      {{ userDetails?.sub_counties_name }}
                    </div>
                  </div>
                  <div class="mb-3">
                    <label class="form-label fw-medium">Constituency</label>
                    <div class="form-control-plaintext border rounded bg-white p-2">
                      {{ userDetails?.con_counties_name }}
                    </div>
                  </div>
                  <div class="mb-3">
                    <label class="form-label fw-medium">Postal Code *</label>
                    <div class="form-control-plaintext border rounded bg-white p-2">
                      {{ userDetails?.TNT_DESCRIPTION }}
                    </div>
                  </div>
                  <!-- <div class="mb-3">
                    <label class="form-label fw-medium">Institution Type</label>
                    <div class="form-control-plaintext border rounded bg-white p-2">
                      {{ userDetails?.institution_type == 2 : 'Girls School': userDetails?.institution_type == 1 ? 'Boys School' : 'Mixed School' }}
                    </div>
                  </div> -->

                </div>

                <div class="col-md-4">
                  <h5 class="border-bottom pb-2">Additional Information</h5>
                  <div class="mb-3">
                    <label class="form-label fw-medium">Institution Level *</label>
                    <div class="form-control-plaintext border rounded bg-white p-2">
                      {{ userDetails?.level_name }}
                    </div>
                  </div>
                  <div class="mb-3">
                    <label class="form-label fw-medium">School Categories</label>
                    <div class="form-control-plaintext border rounded bg-white p-2">
                      {{ userDetails?.school_category_name }}
                    </div>
                  </div>
                  <div class="mb-3">
                    <label class="form-label fw-medium">Application Type</label>
                    <div class="form-control-plaintext border rounded bg-white p-2">
                      {{
                      userDetails?.applicationtype == 1
                      ? "Public"
                      : userDetails?.applicationtype == 2
                      ? "Private"
                      : ""
                      }}
                    </div>
                  </div>
                  <div class="mb-3">
                    <label class="form-label fw-medium">Institution Postal Location</label>
                    <div class="form-control-plaintext border rounded bg-white p-2">
                      {{ userDetails?.schoollocation }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Comments Tab -->
          <div class="tab-pane fade" id="comments" role="tabpanel">
            <div class="row">
              <div class="col-md-6">
                <div class="card">
                  <div class="card-header">
                    <h6 class="text-primary mb-0">SCDE Comments</h6>
                    <small class="text-muted">Read-only - View only</small>
                  </div>
                  <div class="card-body">
                    <div class="bg-light p-3 rounded border">
                      {{
                      approveData?.scde_comments ||
                      "No SCDE comments available."
                      }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="card">
                  <div class="card-header">
                    <h6 class="text-primary mb-0">SCQASO Comments</h6>
                    <small class="text-muted">Read-only - View only</small>
                  </div>
                  <div class="card-body">
                    <div class="bg-light p-3 rounded border">
                      {{
                      approveData?.qaso_comments ||
                      "No SCQASO comments available."
                      }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="card">
                  <div class="card-header">
                    <h6 class="text-primary mb-0">CQASO Comments</h6>
                    <small class="text-muted">Read-only - View only</small>
                  </div>
                  <div class="card-body">
                    <div class="bg-light p-3 rounded border">
                      {{
                      approveData?.CQASO_COMMENTS ||
                      "No CQASO comments available."
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card mt-3">
              <div class="card-header">
                <h6 class="text-primary mb-0">SCQASO Inspection Report</h6>
              </div>
              <div class="card-body" *ngFor="let s of qasoUploadFile">
                <div class="p-3 bg-light rounded border">
                  <div class="">
                    <i class="fas fa-file-text text-primary fa-2x me-3"></i>
                    <div>
                      <h6 class="mb-1">
                        QASO_Inspection_Report_{{ approveData?.TNT_NAME }}.pdf
                      </h6>
                      <!-- <small class="text-muted">Uploaded on: Jan 15, 2024 | Size: 2.3 MB</small> -->
                      <!-- <small class="text-muted"
                        >Uploaded on: Jan 15, 2024</small
                      >
                      <div class="text-success">
                        <small>✓ Report approved and finalized</small>
                      </div> -->
                    </div>
                  </div>
                  <div class="">
                    <button class="btn btn-outline-primary btn-sm"
                      (click)="viewInsepectionReport(s.upload_file, 'view')">
                      <i class="fas fa-eye me-1"></i> View Report
                    </button> &nbsp;
                    <button class="btn btn-outline-secondary btn-sm"
                      (click)="viewInsepectionReport(s.upload_file, 'download')">
                      <i class="fas fa-download me-1"></i> Download
                    </button>
                  </div>
                </div>
              </div>
              <div class="card-body" *ngIf="qasoUploadFile.length == 0">
                <div class="d-xl-flex align-items-xl-center justify-content-xl-between p-3 bg-light rounded border">
                  <div class="">
                    <i class="fas fa-file-text text-primary fa-2x me-3"></i>
                    <div>
                      <h6 class="mb-1">
                        QASO_Inspection_Report_{{ approveData?.TNT_NAME }}.pdf
                      </h6>
                    </div>
                  </div>
                  <div class="d-flex gap-2">
                    <button class="btn btn-outline-primary btn-sm" (click)="viewInsepectionReport('', 'view')">
                      <i class="fas fa-eye me-1"></i> View Report
                    </button>
                    <button class="btn btn-outline-secondary btn-sm" (click)="viewInsepectionReport('', 'download')">
                      <i class="fas fa-download me-1"></i> Download
                    </button>
                  </div>
                </div>
                <!-- <h5>No SCQASO Inspection Report Available.</h5> -->
              </div>
            </div>
            <div class="card mt-3">
              <div class="card-header">
                <h6 class="text-primary mb-0">CQASO Inspection Report</h6>
              </div>
              <div class="card-body">
                <div class="d-xl-flex align-items-xl-center justify-content-xl-between bg-light rounded border">
                  <div class="">
                    <i class="fas fa-file-text text-primary fa-2x me-3"></i>
                    <div>
                      <h6 class="mb-1">
                        CQASO_Inspection_Report_{{ approveData?.TNT_NAME }}.pdf
                      </h6>
                      <!-- <small class="text-muted"
                        >Uploaded on: Jan 15, 2024 | Size: 2.3 MB</small
                      >
                      <div class="text-success">
                        <small>✓ Report approved and finalized</small>
                      </div> -->
                    </div>
                  </div>
                  <div class="d-flex gap-2">
                    <button class="btn btn-outline-primary btn-sm" (click)="viewCQASODocument(approveData, 'view')">
                      <i class="fas fa-eye me-1"></i> View Report
                    </button>
                    <button class="btn btn-outline-secondary btn-sm"
                      (click)="viewCQASODocument(approveData, 'download')">
                      <i class="fas fa-download me-1"></i> Download
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="card mt-3 d-none">
              <div class="card-header">
                <h6 class="text-primary mb-0">CEB Minutes of Approval</h6>
              </div>
              <div class="card-body">
                <div class="d-xl-flex align-items-xl-center justify-content-xl-between p-3 bg-light rounded border">
                  <div class="d-flex align-items-center">
                    <i class="fas fa-file-text text-primary fa-2x me-3"></i>
                    <div>
                      <h6 class="mb-1">
                        CEB_Inspection_Report_{{ approveData?.TNT_NAME }}.pdf
                      </h6>
                      <!-- <small class="text-muted"
                        >Uploaded on: Jan 15, 2024 | Size: 2.3 MB</small
                      >
                      <div class="text-success">
                        <small>✓ Report approved and finalized</small>
                      </div> -->
                    </div>
                  </div>
                  <div class="d-flex gap-2">
                    <button class="btn btn-outline-primary btn-sm" (click)="viewCBEDocument(approveData, 'view')">
                      <i class="fas fa-eye me-1"></i> View Report
                    </button>
                    <button class="btn btn-outline-secondary btn-sm" (click)="viewCBEDocument(approveData, 'download')">
                      <i class="fas fa-download me-1"></i> Download
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- </div> -->
          </div>
          <!-- Actions Tab -->
          <div class="tab-pane fade d-none" id="actions" role="tabpanel">
            <div class="card" *ngIf="item">
              <div class="card-header">
                <h6 class="text-primary mb-0">Registration Decision</h6>
              </div>
              <div class="card-body text-center">
                <div class="mb-4">
                  <button
                    *ngIf="item.IS_APPROVED == 1 && item.submission_status == 2 && (item.CQASO_USERID == null || item.CQASO_USERID == 0 || item.CQASO_SUBMISSION_STATUS == 1)"
                    class="btn btn-success btn-lg me-3" data-bs-target="#approveModal" data-bs-toggle="modal"
                    (click)="getStatus(item, 1)" title="Approve">
                    <i class="fas fa-check-circle me-2"></i> Approve
                    Registration
                  </button>
                  <button
                    *ngIf="item.IS_APPROVED == 1 && item.submission_status == 2 && (item.CQASO_USERID == null || item.CQASO_USERID == 0 || item.CQASO_SUBMISSION_STATUS == 1)"
                    class="btn btn-danger btn-lg" data-bs-target="#commentsModal" data-bs-toggle="modal"
                    (click)="getStatus(item, 2)" title="Reject">
                    <i class="fas fa-times-circle me-2"></i> Reject Registration
                  </button>
                  <!-- <button *ngIf="shouldShowApprovalActions(item)" class="btn btn-danger btn-lg"
                    data-bs-target="#commentsModal" data-bs-toggle="modal" (click)="getStatus(item, 2)" title="Reject">
                    <i class="fas fa-times-circle me-2"></i> Reject Registration
                  </button> -->
                  <span *ngIf="item.submission_status == 4 && item.IS_APPROVED == 2" class="badge bg-success ms-1">
                    <h5>Approved</h5>
                  </span>
                  <span *ngIf="
                      item.submission_status == 5 &&
                      ![2, 4, 5].includes(item.IS_APPROVED)
                    " class="badge bg-danger ms-1">
                    <h5>Rejected</h5>
                  </span>
                </div>
                <hr />
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-danger" data-bs-dismiss="modal" id="institutnDtlsId" (click)="close()">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</div>